import React from 'react';
import { Route } from 'react-router-dom';
import { SalesLoadingDialog } from './sales-loading-dialog/SalesLoadingDialog';
import { SaleDeleteDialog } from './sale-delete-dialog/SaleDeleteDialog';
import { SalesUIProvider } from './SalesUIContext';
import SalesCard from './SalesCard';

const SalesPage = ({ history }) => {
  const SalesUIEvents = {
    openCreateSaleDialog: () => {
      history.push('/sales/new');
    },
    openViewSaleDialog: (id) => {
      history.push(`/sales/${id}/edit`);
    },
    openDeleteSaleDialog: (id) => {
      history.push(`/sales/${id}/delete`);
    },
  };

  return (
    <SalesUIProvider SalesUIEvents={SalesUIEvents}>
      <SalesLoadingDialog />
      <Route path='/sales/:id/delete'>
        {({ history, match }) => (
          <SaleDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push('/sales');
            }}
          />
        )}
      </Route>
      <SalesCard props />
    </SalesUIProvider>
  );
};

export default SalesPage;
